import React from 'react'

export default function RoomEquipment({roomEquipment}) {
  return (
    <>
    <section className="roomdetail-equip">
        <div className="container">
            <div className="row">
                <div className="col-lg-12">
                    <h2 className="heading center-heading">Rooms & Equipments</h2>
                    <p>{roomEquipment.description}</p>
                    <div className="roomfeature-list wow animate__animated animate__slideInUp" data-wow-delay="0.1s" data-wow-duration="1.1s">
                        {roomEquipment.equipment.map((column, colIndex) => (
                            <ul key={colIndex}>
                                {column.map((item, itemIndex) => (
                                    <li key={itemIndex}>{item}</li>
                                ))}
                            </ul>
                        ))}
                    </div>
                </div>

            </div>
        </div>
    </section>
    </>
  )
}
